import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, MenuItem, TextField } from "@mui/material";
import { fetchTags } from "../slices/tagsSlice";
import { LoadingTextField } from "./LoadingTextField";
import { MyListApi } from "../utils/restApi";

export const TagChooser = ({ curTag, onSelect, sx = {} }) => {

    const dispatch = useDispatch();
    const { tags, status, error } = useSelector(state => state.tags);
    // const [tags, setTags] = useState([]);
    const [tag, setTag] = useState('');

    // console.log('tags', tags);

    useEffect(() => {
        if (status == 'idle') {
            dispatch(fetchTags());
        } else if (status === 'succeeded') {
            if (curTag) {
                const selectedTag = tags.find(t => t.name === curTag);
                setTag(selectedTag?.name || '');
                if (onSelect) {
                    onSelect(selectedTag || null);
                }
            }
        }
    }, [status, dispatch]);

    const handleChange = event => {
        const selectedTag = tags.find(t => t.name === event.target.value);
        setTag(selectedTag?.name || '');
        if (onSelect) {
            onSelect(selectedTag || null);
        }
    }

    const hasTags = (!tags || tags.length) !== 0;
    const isDisabled = false; //curTag !== undefined && curTag !== null;

    // console.log('curTag', curTag);
    // console.log('isDisabled', isDisabled);

    return (
        <Box sx={{ width: '100%' }}>
            {hasTags !== 0 ?
                <TextField
                    variant="filled"
                    select
                    sx={{ width: '100%'}}
                    disabled={isDisabled}
                    size="small"
                    value={tag}
                    onChange={handleChange}
                    label="Explore"
                >
                    <MenuItem value=''><em>none</em></MenuItem>
                    {tags.map(t => {
                        const tagName = t.name.split('_').map(s => `${s[0].toUpperCase()}${s.slice(1)}`).join(' ');
                        const isHidden = t.system;
                        return (<MenuItem key={t.id} value={t.name} style={{ display: isHidden ? 'none' : 'inherit' }} >{tagName}</MenuItem>)
                    })}
                </TextField>
                :
                <LoadingTextField />
            }
        </Box>
    );
}